const palette = {
  primary: {
    light: '#dede',
    main: '#3399ff',
    dark: '#005fbe',
    contrastText: '#FFF'
  },
  text: {
    primary: '#38424a',
    secondary: '#949494'
  }
}

export default palette
